import type {
  AssetTimelineExtraItemConfig,
  AssetTimelineExtraItemSlug,
  AssetTimelineItemType,
} from "./asset-timeline.type";

import {
  mdiAccount,
  mdiRobotIndustrial,
  mdiArrowCollapseDown,
  mdiPower,
  mdiTriangle,
  mdiRobotDead,
  mdiAutorenew,
  mdiPowerSleep,
  mdiHeart,
  mdiTriangleOutline,
  mdiTapeMeasure,
  mdiCalendarCheck,
  mdiCalendarToday,
} from "@mdi/js";

export const ASSET_TIMELINE_ITEM_ICONS = {
  mdiAccount,
  mdiRobotIndustrial,
  mdiArrowCollapseDown,
  mdiPower,
  mdiTriangle,
  mdiRobotDead,
  mdiAutorenew,
  mdiPowerSleep,
  mdiHeart,
  mdiTriangleOutline,
  mdiTapeMeasure,
  mdiCalendarCheck,
  mdiCalendarToday,
};

export const ASSET_TIMELINE_ITEM_TYPES: AssetTimelineItemType[] = [
  "asset-event",
  "custom-asset-event",
  "custom-event",
];

export const ASSET_TIMELINE_DEFAULT_ITEM_COLOR = "#575757";

export const ASSET_TIMELINE_EXTRA_ITEMS: Record<
  AssetTimelineExtraItemSlug,
  AssetTimelineExtraItemConfig
> = {
  manufactured: {
    type: "custom-asset-event",
    color: "#004a0f",
    icon: mdiRobotIndustrial,
  },
  commissioned: {
    type: "custom-asset-event",
    color: "#004a0f",
    icon: mdiPower,
  },
  "theoretical-end-of-life": {
    type: "custom-asset-event",
    color: "#575757",
    icon: mdiPowerSleep,
    isIndicator: true,
  },
  today: {
    type: "custom-event",
    color: ASSET_TIMELINE_DEFAULT_ITEM_COLOR,
    icon: mdiCalendarToday,
    isIndicator: true,
  },
};
